import { NAV_PATHS } from '@modules/common/constants';
import { BANNER_HEIGHT } from '@modules/infoBanner/constants';

import { useIsInfoBannerVisible } from '@modules/infoBanner/hooks';
import {
  WORKSPACE_MENU_SECTIONS,
  WORKSPACE_MENU_SECTIONS_CONFIG_URLS,
} from '@modules/workspaceSettings/constants';
import { useIsFeedbackTranslationsEnabled } from '@modules/workspaceSettings/hooks/useIsFeedbackTranslationsEnabled';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';

interface WorkspaceSettingsMenuListParams {
  selectedWorkspaceSetting?: string;
  isOnboardingPageVariant: boolean;
}

const DEFAULT_HEIGHT = '87vh';
const FULLPAGE_HEIGHT = '95vh';

export const WorkspaceSettingsMenuList = ({
  selectedWorkspaceSetting = WORKSPACE_MENU_SECTIONS_CONFIG_URLS.SSO_SETTINGS,
  isOnboardingPageVariant,
}: WorkspaceSettingsMenuListParams) => {
  const isInfoBannerVisible = useIsInfoBannerVisible();

  const pageHeight = isOnboardingPageVariant ? FULLPAGE_HEIGHT : DEFAULT_HEIGHT;

  const isFeedbackTranslationsEnabled = useIsFeedbackTranslationsEnabled();

  return (
    <Stack
      width="25vw"
      maxWidth={300}
      minWidth={200}
      sx={{
        height: isInfoBannerVisible
          ? `calc(${pageHeight} - ${BANNER_HEIGHT}px)`
          : pageHeight,
        borderRight: '1px solid',
        borderColor: 'divider',
        overflowY: 'auto',
        pt: 3,
      }}
      spacing={0.5}
    >
      {WORKSPACE_MENU_SECTIONS.map((section) => (
        <Stack key={section.title}>
          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{ px: 3.5 }}
          >
            {section.title}
          </Typography>
          <List>
            {section.items.map((item) => {
              if (
                item.url ===
                  WORKSPACE_MENU_SECTIONS_CONFIG_URLS.FEEDBACK_TRANSLATIONS &&
                !isFeedbackTranslationsEnabled
              ) {
                return null;
              }
              return (
                <ListItem
                  key={item.text}
                  disablePadding
                  sx={{
                    color:
                      item.url === selectedWorkspaceSetting
                        ? 'primary.main'
                        : 'text.primary',
                  }}
                >
                  <ListItemButton
                    sx={{ px: 3.5 }}
                    selected={selectedWorkspaceSetting === item.url}
                    component={Link}
                    to={`/${NAV_PATHS.WORKSPACE_SETTINGS}/${item.url}`}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: 1,
                        color:
                          item.url === selectedWorkspaceSetting
                            ? 'primary.main'
                            : 'text.primary',
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.text} sx={{ ml: 1 }} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Stack>
      ))}
    </Stack>
  );
};
